import { ByteFormat } from '../enums';

export const ByteFormatLabel = {
	[ByteFormat.BYTE]: 'b',
	[ByteFormat.KILOBYTE]: 'kb',
	[ByteFormat.MEGABYTE]: 'mb',
	[ByteFormat.GIGABYTE]: 'gb'
};
